import { FormSection } from '@/containers/forms/FormSection'
import type { BaseContainerProps } from '.'
import { LocationForm } from '../forms/LocationForm'

export const Location = (props: BaseContainerProps) => {
  return (
    <FormSection {...props}>
      <LocationForm />
    </FormSection>
  )
}